// Validation utility functions
export const validateUrl = (url) => {
  if (!url || url.trim() === '') {
    return 'URL is required';
  }
  
  try {
    // Add protocol if missing
    let validUrl = url;
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      validUrl = 'https://' + url;
    }
    
    new URL(validUrl);
    return null; // Valid URL
  } catch (error) {
    return 'Please enter a valid URL';
  }
};

export const validateTitle = (title) => {
  if (!title || title.trim() === '') {
    return 'Title is required';
  }
  
  if (title.trim().length < 3) {
    return 'Title must be at least 3 characters long';
  }
  
  return null; // Valid title
};

export const formatUrl = (url) => {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return 'https://' + url;
  }
  return url;
};